import { useState } from 'react'
import { Check, Copy } from 'lucide-react'
import { cn } from '@/lib/utils'

/** An id or key in the monospace face, with a click-to-copy. */
export function MonoId({ value, className }: { value: string; className?: string }) {
  const [copied, setCopied] = useState(false)
  if (!value) return <span className="text-muted-foreground">—</span>
  const copy = async (e: React.MouseEvent) => {
    e.stopPropagation()
    try {
      await navigator.clipboard.writeText(value)
      setCopied(true)
      setTimeout(() => setCopied(false), 1200)
    } catch {
      /* clipboard can be blocked; the id is still selectable */
    }
  }
  return (
    <button
      type="button"
      onClick={copy}
      title="Copy"
      className={cn('group inline-flex max-w-full items-center gap-1 rounded font-mono text-xs text-muted-foreground hover:text-foreground', className)}
    >
      <span className="truncate">{value}</span>
      {copied ? <Check className="size-3 shrink-0 text-ok" /> : <Copy className="size-3 shrink-0 opacity-0 group-hover:opacity-100 group-focus-visible:opacity-100" />}
      <span className="sr-only">{copied ? 'Copied' : 'Copy'}</span>
    </button>
  )
}
